import { Checkbox, Dialog, DialogTitle, FormControlLabel, Grid, TextField } from '@mui/material'
import React, { useState } from 'react'
import MyButton from '../../ui/MyButton'
import SendIcon from '@mui/icons-material/Send';

const CreatingAComplaintDialog = ({ open, handleClose, bookedLessonId, createAComplaint }) => {
  const [content, setContent] = useState('')
  const [isRequestedRefund, setIsRequestedRefund] = useState(false)

  const handleChangeContent = (e) => {
    setContent(e.target.value)
  }

  const handleChangeRefund = (e) => {
    setIsRequestedRefund(e.target.checked)
  }

  const handleSendComplaint = async () => {
    try {
      createAComplaint({ bookedLessonId, content, isRequestedRefund })

      handleClose()
    } catch (err) {
      if (err) {
        handleClose()
      }
    }
  }


  return <>
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle style={{ padding: '2em 3em 0' }}>Gửi khiếu nại về bài học</DialogTitle>
      <Grid container direction='column' justifyContent='center' alignItems='center' spacing={2}>
        <Grid item>
          <TextField error={isRequestedRefund && !content} helperText={isRequestedRefund && !content ? 'Vui lòng điền nội dung khiếu nại' : ''} label='Nội dung' value={content} onChange={handleChangeContent} multiline inputProps={{ style: { minHeight: '10em', minWidth: '15em' } }} />
        </Grid>

        <Grid item>
          <FormControlLabel label="Yêu cầu hoàn tiền học phí" control={<Checkbox checked={isRequestedRefund} onChange={handleChangeRefund} />} labelPlacement='start' />
        </Grid>

        <Grid item container justifyContent='center' alignItems="center" spacing={2} sx={{ paddingBottom: '2em' }}>
          <Grid item><MyButton onClick={handleClose}>Đóng</MyButton></Grid>

          <Grid item><MyButton onClick={handleSendComplaint} disabled={isRequestedRefund && !content}>Gửi&nbsp;<SendIcon /></MyButton></Grid>
        </Grid>
      </Grid>
    </Dialog>
  </>;
}

export default CreatingAComplaintDialog
